const Lightpick = require('./../plugins/lightpick');

$('.booking-bar__form').each(function () {

	let duration = 1, // number of nights
		$customDuration = $(this).find('[data-custom-duration]');

	if ($customDuration.length > 0) {
		let newDuration = $customDuration.data('custom-duration');

		if (typeof newDuration !== 'undefined') {
			duration = parseInt(newDuration);
		}
	}

	let start = moment(),
		end = moment().add(duration, 'days');

	let $customStart = $(this).find('[data-custom-start]');

	if ($customStart.length > 0) {
		let newStartDate = $customStart.data('custom-start');

		if (typeof newStartDate !== 'undefined') {
			// check if custom start_date hasnt already passed
			if (moment(newStartDate, 'DD/MM/YYYY').isAfter(moment())) {
				start = moment(newStartDate, 'DD/MM/YYYY');
				end = moment(newStartDate, 'DD/MM/YYYY').add(duration, 'days');
			}
		}
	}

	let $form = $(this),
		$hotelIdField = $form.find('.input-hotel-id'),
		footerHTML = $form.find('[data-footer-html]').data('footer-html'),
		$fieldGuests = $form.find('.field--guests'),
		$checkinLabel = $form.find('.custom-select--dates .check-in'),
		$checkinField = $form.find('.input-checkin'),
		$checkoutLabel = $form.find('.custom-select--dates .check-out'),
		$checkoutField = $form.find('.input-checkout'),
		$childCountField = $form.find('.input-childcount'),
		$childContainer = $form.find('.child-ages'),
		$childGrid = $form.find('.child-ages__grid'),
		$childInputTemplate = $form.find('#template-child-age-input'),
		$nights = $form.find('.custom-select--dates .nights');

	let showHideFields = function () {
		let $el = $hotelIdField.filter(':checked');
		if($el.data('hide-guests') == '1') {
			$fieldGuests.hide();
		} else {
			$fieldGuests.show();
		}
	}

	$hotelIdField.on('change', (event) => {
		showHideFields();
	});

	showHideFields();

	//set correct url on form based on hotel
	/*
	if ($hotelIdField.is('input[type="radio"]')) {
		$hotelIdField.on('change', () => {
			$form.attr('action', $form.find('.input-hotel-id:checked').data('booking-url'));
		});
		$hotelIdField.trigger('change');
	} else {
		$form.attr('action', $form.find('.input-hotel-id').data('booking-url'));
	}
	*/

	let renderChildAgeFields = (num) => {
		let $fields = $childGrid.find('.age');
		let currentChildCount = parseInt($fields.length);

		if (num > currentChildCount) {
			let toAdd = num - currentChildCount;
			let $childInputField = $childInputTemplate.html();
			for (let i = 0; i < toAdd; i++) {
				$childGrid.append($childInputField);
			}
		}
		if (num < currentChildCount) {
			let toRemove = currentChildCount - num;
			$fields.slice(-toRemove).remove();
		}

		if (num > 0) {
			$childContainer.removeClass('child-ages--hidden');
		} else {
			$childContainer.addClass('child-ages--hidden')
		}
	}

	let currentChildCount = parseInt($childCountField.val());
	renderChildAgeFields(currentChildCount);

	$childCountField.on('change', (e) => {
		let childCount = parseInt($childCountField.val());
		renderChildAgeFields(childCount);
	});

	if (typeof footerHTML === 'undefined') {
		footerHTML = '';
	}

	try {
		let prices = [];

		let picker = new Lightpick({
			field: $form.find('.booking--datepicker')[0],
			singleDate: false,
			numberOfColumns: 2,
			numberOfMonths: 2,
			disabledDatesInRange: false,
			minDate: start,
			footer: footerHTML,
			onDayRender: (div, date) => {
				//console.log(getPrice(date))
			},
			onOpen: () => {
				//setDatePickerPrices();

				// demo functionality for styling of prices inside datepicker
				// if no price, just insert <div class="price">&ndash;</div>
				//$('.lightpick__day.is-available:not(.is-today)').each(function () {
				//	$(this).append('<div class="price">' + (Math.floor(Math.random() * (300 - 100 + 1)) + 100) + '</div>');
				//});
			},
			onSelect: (startDate, endDate) => {
				$checkinLabel.text(startDate.format('ddd DD.MM'));
				$checkinField.val(startDate.format('DD-MM-YYYY'));
				$checkoutLabel.text(endDate.format('ddd DD.MM'));
				$checkoutField.val(endDate.format('DD-MM-YYYY'));

				let days = moment.duration(endDate.diff(startDate)).asDays();

				if (days < 0) { // if an end-date is selected thats before start-date
					days = 0;
				} else {
					days = Math.round(days);
				}

				if (days === 1) {
					$nights.text(days + ' ' + $nights.data('text-singular'));
				} else {
					$nights.text(days + ' ' + $nights.data('text-multiple'));
				}
			}
		});

		picker.setDateRange(start, end);
	} catch (err) {
		console.log('datepicker could not be initialised');
		//lightpicker could not be initialised so we fill the date in text fields
		$checkinLabel.text(start.format('ddd DD.MM'));
		$checkinField.val(start.format('DD-MM-YYYY'));
		$checkoutLabel.text(end.format('ddd DD.MM'));
		$checkoutField.val(end.format('DD-MM-YYYY'));
	}
});


